const mutations = {
  set(state, { type, value }) {
    state[type] = value;
  },
};

const actions = {
  setFilterData({ commit }, data) {
    commit('set', { type: 'filterData', value: data });
  },
  setCardData({ commit }, data) {
    commit('set', { type: 'cardData', value: { ...data } });
  },
  setIsNew({ commit }, data) {
    commit('set', { type: 'isNew', value: data });
  },
  setisReadonlyMode({ commit }, data) {
    commit('set', { type: 'isReadonlyMode', value: data });
  },
};

const getFullName = (userCardData) => `${userCardData.lastName ?? ''} ${userCardData.firstName ?? ''} ${userCardData.middleName ?? ''}`;

const getters = {
  getFilterData: (state) => state.filterData,
  getCardData: (state) => state.cardData,
  getIsCardFilled: (state) => Object.keys(state.cardData).length > 0,
  getIsNew: (state) => state.isNew,
  getisReadonlyMode: (state) => state.isReadonlyMode,
  getUserFullName: (state) => getFullName(state.cardData),
};

const state = {
  filterData: {},
  cardData: {},
  isNew: false,
  isReadonlyMode: true,
};

export default {
  namespaced: true,
  actions,
  getters,
  state,
  mutations,
};
